import type { InferRpcDefinition } from "@redotech/rpc/definition";
import { authorizationCode } from "./schema/oauth/authorizationCode";

export const rpcDefinition = {
  authorizationCode,
};

export type RedoAuthRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
